import { useState, useEffect } from 'react';
import useAxios from 'axios-hooks';

export const useSchool = () => {
  const [params, setParams] = useState();

  //Programs request
  const [
    { data: dataSchools, loading: loadingSchools, error: errorSchools },
    executeSchools,
  ] = useAxios({ url: 'schools', params }, { manual: true });


  useEffect(() => {
    if(params) {
      executeSchools();
    }
  }, [params])

  return {
    dataSchools,
    loadingSchools,
    errorSchools,
    params,
    setParams,
  };
};
